"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var _core = require("@apollo/client/core");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// Based on https://github.com/newsiberian/apollo-link-token-refresh/
var OperationQueuing = /*#__PURE__*/function () {
  function OperationQueuing() {
    (0, _classCallCheck2["default"])(this, OperationQueuing);
    this.queuedRequests = [];
  }
  return (0, _createClass2["default"])(OperationQueuing, [{
    key: "enqueueRequest",
    value: function enqueueRequest(request) {
      var _this = this;
      return new _core.Observable(function (observer) {
        _this.queuedRequests.push(request);

        // Observer contains next, error and complete
        request.subscriber = observer;
      });
    }
  }, {
    key: "consumeQueue",
    value: function consumeQueue() {
      var getOperationContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      this.queuedRequests.forEach(function (request) {
        // Setting context to be used in the HttpLink
        var context = getOperationContext(request.operation);
        if (context) {
          request.operation.setContext(function () {
            return context;
          });
        }
        // Subscribing the queued subscribers to the forwarded observable ensures
        // execution
        request.forward(request.operation).subscribe(request.subscriber);
      });
      this.queuedRequests = [];
    }
  }]);
}();
var TokenFetchLink = exports["default"] = /*#__PURE__*/function (_ApolloLink) {
  function TokenFetchLink(params) {
    var _this2;
    (0, _classCallCheck2["default"])(this, TokenFetchLink);
    _this2 = _callSuper(this, TokenFetchLink);
    _this2.isTokenValid = params.isTokenValid;
    _this2.fetchAccessToken = params.fetchAccessToken;
    _this2.handleResponse = params.handleResponse || _identity["default"];
    _this2.getOperationContext = params.getOperationContext;
    _this2.handleError = typeof params.handleError === "function" ? params.handleError : function (err) {
      console.error(err);
    };
    _this2.fetching = false;
    _this2.queue = new OperationQueuing();
    return _this2;
  }
  (0, _inherits2["default"])(TokenFetchLink, _ApolloLink);
  return (0, _createClass2["default"])(TokenFetchLink, [{
    key: "request",
    value: function request(operation, forward) {
      var _this3 = this;
      if (typeof forward !== "function") {
        throw new Error("[Token Refresh Link]: Token Refresh Link is a non-terminating link and should not be the last in the composed chain");
      }

      // If token does not exist, which could mean that this is a not registered
      // user request, or if it is is not expired -- act as always
      if (this.isTokenValid() || operation.operationName === "ResetPassword") {
        return forward(operation);
      }
      if (!this.fetching) {
        this.fetching = true;
        this.fetchAccessToken().then(this.handleResponse(operation))["catch"](this.handleError)["finally"](function () {
          _this3.fetching = false;
          // Is this meant to add
          _this3.queue.consumeQueue(_this3.getOperationContext);
        });
      }
      var result = this.queue.enqueueRequest({
        operation: operation,
        forward: forward
      });
      return result;
    }
  }]);
}(_core.ApolloLink);